<template>
  <nav>
    <h4>Разделы</h4>
    <ul v-if="!isEmpty(storedRoutes)" class="menu text-muted">
      <nav-tree-item
        v-for="item in navRoutes"
        :key="item.id || item.linkTo"
        :item="item" />
    </ul>
  </nav>
</template>

<script>
  import NavTreeItem from './NavTreeItem'
  import { flatten, get, isEmpty } from 'lodash-es'
  import { mapState } from 'vuex'

  export default {
    components: {
      NavTreeItem
    },

    computed: {
      navRoutes() {
        const rootRoutes = this.$router.options.routes
          .find(route => route.meta.root).children
          .filter(route => process.env.NODE_ENV === 'development' || route.meta.breadcrumb.linkTo !== 'design_system')

        return this.getNavRoutes(rootRoutes)
      },
      ...mapState({
        storedRoutes: state => state.routes.routes,
        notifications: state => state.notifications
      })
    },

    methods: {
      getNavRoutes(routes) {
        const routesNode = routes
          .filter(route => route.meta && route.meta.breadcrumb)
          .map(route => {
            const breadcrumb = route.meta.breadcrumb
            const notificationsPath = route.meta.notificationsPath
            const notifications = this.notifications[notificationsPath]

            if (breadcrumb.storePath) {
              return get(this.storedRoutes, breadcrumb.storePath)
            }

            let children = route.children && route.children.filter(route => !route.meta.excludeFromMenu)

            if (children && children.length) {
              children = this.getNavRoutes(children)
            }

            return {
              linkText: breadcrumb.linkText,
              linkTo: breadcrumb.linkTo,
              notifications,
              children
            }
          })

        return flatten(routesNode)
      },
      isEmpty
    }
  }
</script>